<template>
  <div class="sale-page">
    <SaleStep />
  </div>
</template>
<script>
// Components
import SaleStep from '@/components/common/SaleStep/SaleStep.vue';
export default {
  name: 'SalePage',
  components: {
    SaleStep
  }
};
</script>
